/**
 * Sharing Presentational Component
 * View: Displays sharing buttons
 */

require('../styles/sharing.scss');

import React from 'react';

class Sharing extends React.Component {

  render() {
    var url = this.props.url || location.href,
        twitterText = this.props.twitterText? '&text=' + encodeURIComponent(this.props.twitterText) : '',
        facebookText = this.props.facebookText? '&text=' +encodeURIComponent(this.props.facebookText) : '',
        hashtags = this.props.hashtags? '&hashtags='+this.props.hashtags : '',
        twitterUser = this.props.twitterUser? '&via=' + this.props.twitterUser : '',
        encodedUrl;

    url = this.props.hash ? (url + '#' + this.props.hash) : url;
    encodedUrl = encodeURIComponent(url);

    return (
      <div className={this.props.classes}>
        <span>Partager&nbsp;:</span>
        <a className="facebook-sharing" target="facebook.com/sharer" href={'https://www.facebook.com/sharer/sharer.php?u=' + encodedUrl }>
          <svg width="42" height="42" viewBox="0 0 42 42">
            <path className="facebook-sharing-icon" fillRule="evenodd" clipRule="evenodd" fill={this.props.color} d="M21 0C9.4 0 0 9.4 0 21s9.4 21 21 21 21-9.4 21-21S32.6 0 21 0zm5.5 21.5h-3.6V34h-5.4V21.5H15v-4.4h2.6v-2.9c0-2 1-5.2 5.4-5.2h4v4.3h-2.9c-.5 0-1.1.2-1.1 1.2v2.6h4l-.5 4.4z"/>
          </svg>
        </a>
        <link rel="canonical" href={url} />
        <link rel="me" href={'https://twitter.com/'+ twitterUser} />
        <a className="twitter-sharing" target="twitter.com/tweet" href={'https://twitter.com/intent/tweet?original_referer=' + encodedUrl + '&url=' + encodedUrl + hashtags + twitterText + twitterUser}>
          <svg width="42" height="42" viewBox="0 42 42 42">
            <path className="twitter-sharing-icon" fillRule="evenodd" clipRule="evenodd" fill={this.props.color} d="M21 42C9.4 42 0 51.4 0 63s9.4 21 21 21 21-9.4 21-21-9.4-21-21-21zm11.4 16.2v.7c0 7-5.2 15.1-14.6 15.1-2.9 0-5.6-.9-7.9-2.4.4 0 .8.1 1.2.1 2.4 0 4.6-.8 6.4-2.3-2.2 0-4.1-1.6-4.8-3.7.3.1.6.1 1 .1.5 0 .9-.1 1.4-.2-2.3-.4-4.1-2.6-4.1-5.1v-.1c.7.4 1.5.6 2.3.7-1.4-1-2.3-2.6-2.3-4.4 0-1 .3-1.9.7-2.7 2.5 3.2 6.3 5.3 10.6 5.5-.1-.4-.1-.8-.1-1.2 0-2.9 2.3-5.3 5.1-5.3 1.5 0 2.8.6 3.7 1.7 1.2-.2 2.3-.7 3.3-1.3-.4 1.2-1.2 2.3-2.3 2.9 1-.1 2-.4 2.9-.8-.6 1-1.5 2-2.5 2.7z"/>
          </svg>
        </a>
      </div>
    )
  }
}

Sharing.propTypes = {
  url: React.PropTypes.string,
  hash: React.PropTypes.string, // hash part of the url
  facebookText: React.PropTypes.string, // used by facebook only. default message
  twitterText: React.PropTypes.string, // used by twitter only. default message
  hashtags: React.PropTypes.string,   // used by twitter only. Add hashtags to the message
  twitterUser: React.PropTypes.string, // used by twitter only. Add reference to client twitter account
  color: React.PropTypes.string,
  classes: React.PropTypes.string//
};

Sharing.defaultProps = {
  classes: 'sharing-block',
  color: '#D53844'
};

export default Sharing;



// WEBPACK FOOTER //
// ./src/components/Sharing.js